function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M5.324 30.331c22.405.223 33.608-2.425 33.608-7.945C38.932 14.106 26.95.01 18.667.01 13.144.01 7.027 3.58.317 10.72L5.323 30.33z",
  id: "deliveryAlert_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.417 30.737c21.68-.225 32.521-3.098 32.521-8.618C37.938 13.84 26.951.01 18.667.01 13.144.01 7.027 3.58.317 10.72l5.1 20.017z",
  id: "deliveryAlert_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  id: "deliveryAlert_svg__g",
  d: "M10.455 49.844l27.38-17.341L20.974.99.986 12.714z"
}), /*#__PURE__*/React.createElement("path", {
  id: "deliveryAlert_svg__i",
  d: "M0 0l20.637 8.038 20.8 32.181-24.533-8.606z"
}), /*#__PURE__*/React.createElement("path", {
  id: "deliveryAlert_svg__k",
  d: "M.493 10.03L20.088.91 47.95 28.957 21.405 42.24z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.162 6.7c11.44 0 18.505-1.62 18.505-3.427 0-1.808-6.716-3.273-15-3.273-8.285 0-15 1.465-15 3.273 0 1.807.054 3.426 11.495 3.426z",
  id: "deliveryAlert_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.04 20.765A13.816 13.816 0 010 13.5C0 6.044 5.82 0 13 0s13 6.044 13 13.5c0 1.733-.314 3.39-.887 4.912h.033l-.26.563c-.099.232-.204.461-.316.686l-9.702 21.055a2 2 0 01-3.633 0L2.04 20.765z",
  id: "deliveryAlert_svg__p"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-46.7%",
  y: "-45.6%",
  width: "193.3%",
  height: "191.2%",
  filterUnits: "objectBoundingBox",
  id: "deliveryAlert_svg__b"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "4.66517857 0",
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-46.7%",
  y: "-45.6%",
  width: "193.3%",
  height: "191.2%",
  filterUnits: "objectBoundingBox",
  id: "deliveryAlert_svg__e"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "4.66517857 0",
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-46.7%",
  y: "-458.5%",
  width: "193.3%",
  height: "1017%",
  filterUnits: "objectBoundingBox",
  id: "deliveryAlert_svg__n"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "4.66517857 0",
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-18.202%",
  y1: "103.759%",
  x2: "64.441%",
  y2: "-1.715%",
  id: "deliveryAlert_svg__r"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.468,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("circle", {
  id: "deliveryAlert_svg__q",
  cx: 13,
  cy: 14,
  r: 8
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 42)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "deliveryAlert_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#deliveryAlert_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.667 30.689c8.284 0 15-7.988 15-16.065C18.667 6.547 11.95 0 3.667 0c-8.285 0-15 6.547-15 14.624 0 8.077 6.715 16.065 15 16.065z",
  fillOpacity: 0.277,
  fill: "#844C22",
  filter: "url(#deliveryAlert_svg__b)",
  mask: "url(#deliveryAlert_svg__c)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(57 33)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "deliveryAlert_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#deliveryAlert_svg__d"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.667 30.689c8.284 0 15-7.988 15-16.065C18.667 6.547 11.95 0 3.667 0c-8.285 0-15 6.547-15 14.624 0 8.077 6.715 16.065 15 16.065z",
  fillOpacity: 0.277,
  fill: "#844C22",
  filter: "url(#deliveryAlert_svg__e)",
  mask: "url(#deliveryAlert_svg__f)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 22)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "deliveryAlert_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#deliveryAlert_svg__g"
})), /*#__PURE__*/React.createElement("use", {
  stroke: "#8B572A",
  fill: "#FBE5BE",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xlinkHref: "#deliveryAlert_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.302-26L-34.723 4.644l33.562 3.687 6.808-22.938 11.577 5.85-7.427-1.947-1.495 7.765 6.854 1.903-9.509 4.318-6.808 5.049L-13.7 52.103l49.964 4.238-4.283-46.895-7.36-1.114L5.648 9.446l-3.125 17.37-4.441-3.274L50.295 43.37l59.735-57.975-80.404-7.059-46.532 17.7 9.05 36.241L15.155 43.37l17.902 8.734 13.504-26.37-13.504-40.34 31.679 3.228 19.692 67.72 12.546-4.238-6.561-31.828-5.985-29.031h12.546l9.228 57.836-25.488 23.446-72.413-5.345 5.813-41.449 18.943-1.121-18.943 1.121 2.25-10.232 10.504-2.492c1.803-1.534 2.722-2.721 2.757-3.562.02-.482.64-3.523-2.757-4.801-1.688-.636-5.94-1.09-12.754-1.362l2.25-11.39L8.303-26z",
  stroke: "#FFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#deliveryAlert_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BADD84",
  mask: "url(#deliveryAlert_svg__h)",
  d: "M17.202 16.332l-1.742 8.367 17.422-1.023 5.938-1.358-3.714-7.822-7.966-.501zM-11.528 5.892l9.537 1.274L.5-2.175h-9.692zM12.357 55.76l2.35-11.243 9.283 5.622-1.744 9.946z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21 23)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "deliveryAlert_svg__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#deliveryAlert_svg__i"
})), /*#__PURE__*/React.createElement("use", {
  stroke: "#8B572A",
  fill: "#AC7240",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xlinkHref: "#deliveryAlert_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-13.018-26.676L-34.804 50.75l49.476 4.2-4.357-30.81 8.734-1.598-4.377-9.879L.828 11.531l-17.969 13.076L34.563 50.75c5.073-1.22 8.386-2.796 9.939-4.728 2.33-2.898 6.174-2.303 7.73-6.16 1.038-2.572.813-5.99-.676-10.254L44.502 37.3l-10.809 5.723-7.124-2.112 13.537.892 47.61-57.182-79.618-6.998L-37.98-4.832l54.628 37.744 19.782-1.916 6.554 9.914 1.518-3.611-33.006-52.68L34.563 5.315l-19.891 7.348 7.69 15.794L30.263 43.5l32.101 11.45 12.423-4.2-35.342-28.59-13.613 1.365-5.205-9.025 9.165-1.838L62.365-9.58h12.423l9.138 57.333-25.239 23.243-71.705-5.3L1.092 8.62l18.484-9.754-11.478-5.81-8.413 5.81-12.703-25.542z",
  stroke: "#FFF",
  strokeWidth: 2,
  opacity: 0.368,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#deliveryAlert_svg__j)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#809A57",
  mask: "url(#deliveryAlert_svg__j)",
  d: "M-.647 14.88l-2.006 8.654 14.495-.676 6.225-1.092-4.1-8.194-6.732-.566z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(41 21)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "deliveryAlert_svg__l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#deliveryAlert_svg__k"
})), /*#__PURE__*/React.createElement("use", {
  stroke: "#8B572A",
  fill: "#F4E2C5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xlinkHref: "#deliveryAlert_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2,
  opacity: 0.678,
  mask: "url(#deliveryAlert_svg__l)",
  d: "M-33.765-24.913l-22.2 77.672 50.414 4.214-4.44-30.91 9.438-1.985-4.998-9.528h-13.388l-19.028 11.984 52.685 26.225 54.162-66.34L9.976 25.41 3.535 16.06l19.99-8.88 13.708-7.73L33.8-4.417 25.424.71l-4.598-3.037L32.167-8.91l-44.416-11.691L-59.201-3l50.415 33.395L15.75 32.97l6.425-3.302-30.961-43.25 23.504 19.24-20.269 8.892 7.836 15.845 2.554 13.388 38.208 13.19-13.418-4.214 30.997-36.854-17.579-23.67h15.33l-23.781 19.39 29.692 21.917-7.124 7.885L21.615 8.488l-5.006 2.38 33.145 36.577L39.3 73.069l-73.065-5.316 14.376-57.257L-.553.71-12.25-5.12-20.822.71z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D6F2AB",
  mask: "url(#deliveryAlert_svg__l)",
  d: "M39.646 23.826l7.238 6.798 4.379-5.831-7.972-6.04z"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#8B572A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M41.552 30.951L61.086 22 89 49.913 62.414 63.227zM21 23l20.5 7.975 20.905 32.25-24.502-8.597z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#8B572A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10.457 71.806L38 54.386 20.983 22.996 1 34.677z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(60 37)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "deliveryAlert_svg__o",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#deliveryAlert_svg__m"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.667 6.689c8.284 0 15-.795 15-1.598S8.95 3.636.667 3.636c-8.285 0-15 .652-15 1.455s6.715 1.598 15 1.598z",
  fillOpacity: 0.277,
  fill: "#844C22",
  filter: "url(#deliveryAlert_svg__n)",
  mask: "url(#deliveryAlert_svg__o)"
})), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(50 1)"
}, /*#__PURE__*/React.createElement("use", {
  stroke: "#8B572A",
  fill: "#F83825",
  xlinkHref: "#deliveryAlert_svg__p"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#FEBF7C",
  strokeWidth: 0.5,
  xlinkHref: "#deliveryAlert_svg__p"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 1)"
}, /*#__PURE__*/React.createElement("use", {
  stroke: "#986B43",
  fill: "#FFF",
  xlinkHref: "#deliveryAlert_svg__q"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#FEBF7C",
  strokeWidth: 0.5,
  xlinkHref: "#deliveryAlert_svg__q"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.854 40.342L11.95 18.84c1.544-4.09 1.385-7.889-.478-11.395C9.61 3.938 6.31 1.97 1.572 1.54",
  stroke: "url(#deliveryAlert_svg__r)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "matrix(-1 0 0 1 64.572 1)"
})));
function SvgDeliveryAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 90 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}
export default SvgDeliveryAlert;